import Vue from 'vue'
import Router from 'vue-router'
import {globalConf} from './config.global'

import Home from './views/Home.vue'
import Dati from './views/Dati.vue'
import Report from './views/Report.vue'
import Login from './views/Login.vue'
import Usermanager from './views/Usermanager'
import Anagraficaupload from './views/Anagraficaupload'
import Bilancioupload from './views/Bilancioupload'
import ResetPassword from './views/resetPassword.vue'
import NewPassword from './views/newPassword.vue'
import Zonaupload from './views/Zonaupload.vue'
import Profilo from './views/Profilo.vue'

Vue.use(Router)

function isLogged (to, from, next) {
    Vue.http.post(globalConf.hostlink+'user/islogged', {}, {credentials : true}).then(response => {
        if(response.body.success){
            if(response.body.reset){
                next('/resetpassword')
                return
            }else{
                Vue.prototype.$isAdmin = response.body.isAdmin
                if(to.name != 'login'){
                    next()
                    return
                }
                next('/home')
                return
            }
        }
        Vue.prototype.$isAdmin = false
        next('/login')
    }, response => {
        next('/login')
    })
}

function isLoggedAdmin (to, from, next) {
    Vue.http.post(globalConf.hostlink+'user/islogged', {}, {credentials : true}).then(response => {
        if(response.body.success){
            Vue.prototype.$isAdmin = response.body.isAdmin
            if(to.name != 'login' && response.body.isAdmin){
                next()
                return
            }
            next('/home')
            return
        }
        Vue.prototype.$isAdmin = false
        next('/login')
    }, response => {
        next('/login')
    })
}

function isNotLogged (to, from, next) {
  Vue.http.post(globalConf.hostlink+'user/islogged', {}, {credentials : true}).then(response => {
      if(response.body.success){
        Vue.prototype.$isAdmin = response.body.isAdmin
        next('/home')
        return
      }
      Vue.prototype.$isAdmin = false
      next()
  }, response => {
      next()
  })
}

function isResetPassword (to, from, next) {
    Vue.http.post(globalConf.hostlink+'user/islogged', {}, {credentials : true}).then(response => {
        if(response.body.success){
            if(response.body.reset){
                next()
                return
            }else{
                next('/home')
                return
            }
        }
        next('/login')
        return
    }, response => {
        next('/login')
    })
}

export default new Router({
  mode: 'history',
  routes: [
    {
        path: '/',
        redirect: { path: '/home', }
    },
    {
        path: '/home',
        name: 'home',
        component: Home,
        beforeEnter: isLogged
    },
    {
        path: '/dati',
        name: 'dati',
        component: Dati,
        beforeEnter: isLogged
    },
    {
        path: '/report',
        name: 'report',
        component: Report,
        beforeEnter: isLogged
    },
    {
        path: '/profilo',
        name: 'profilo',
        component: Profilo,
        beforeEnter: isLogged
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
        beforeEnter: isNotLogged
    },
    {
        path: '/usermanager',
        name: 'usermanager',
        component: Usermanager,
        beforeEnter: isLoggedAdmin
    },
    {
        path: '/anagrafica',
        name: 'anagrafica',
        component: Anagraficaupload,
        beforeEnter: isLoggedAdmin
    },
    {
        path: '/bilancio',
        name: 'bilancio',
        component: Bilancioupload,
        beforeEnter: isLoggedAdmin
    },
    {
        path: '/zona',
        name: 'zona',
        component: Zonaupload,
        beforeEnter: isLoggedAdmin
    },
    {
        path: '/resetpassword',
        name: 'reset',
        component: ResetPassword,
        beforeEnter: isResetPassword
    },
    {
        path: '/newpassword/:email/:code',
        name: 'new',
        component: NewPassword
    }
  ]
})
